// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DOMUtils$Showside from "../utils/DOMUtils.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as ObjectFitMath$Showside from "../utils/ObjectFitMath.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EdgeSwipeDetector$Showside from "../utils/EdgeSwipeDetector.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
var getTouchY = function getTouchY(e) {
  return e.touches ? e.touches[0].pageY : 0;
};
function QuickViewSlideUpDrawer(Props) {
  var children = Props.children;
  var media = Props.media;
  var latch = Props.latch;
  var offsetControllerRef = Props.offsetControllerRef;
  var renderViewProductsButtonOpt = Props.renderViewProductsButton;
  var onChangeLatch = Props.onChangeLatch;
  var renderViewProductsButton = renderViewProductsButtonOpt !== undefined ? renderViewProductsButtonOpt : function (show, flip, visualMediaHeight) {
    return null;
  };
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = ViewportContext$Showside.use(undefined);
  var match$2 = match$1.windowSize;
  var windowHeight = match$2.height;
  ConfigurationProvider$Showside.use(undefined);
  var prevLatch = Previous$Showside.usePreviousDistinct(latch);
  var didEdgeSwipe = EdgeSwipeDetector$Showside.useEdgeSwipeDetector(undefined);
  var match$3 = React.useState(function () {
    return 0;
  });
  var setOffset = match$3[1];
  var offset = match$3[0];
  React.useEffect(function () {
    Belt_Option.forEach(offsetControllerRef, function (ref) {
      ref.current = function (newOffset) {
        Curry._1(setOffset, function (param) {
          return newOffset;
        });
      };
    });
  }, []);
  var availableSize_width = match$2.width;
  var availableSize = {
    width: availableSize_width,
    height: windowHeight
  };
  var mediaSize_width = media.originalWidth;
  var mediaSize_height = media.originalHeight;
  var mediaSize = {
    width: mediaSize_width,
    height: mediaSize_height
  };
  var objectFit = ObjectFitMath$Showside.fitAndPosition(availableSize, mediaSize, "scale-down");
  var visualMediaHeight = objectFit.height;
  var visualMediaWidth = objectFit.width;
  var match$4 = React.useState(function () {});
  var setDrag = match$4[1];
  var drag = match$4[0];
  var limit = function (y) {
    return Caml.int_min(30 > y ? 30 : y, visualMediaHeight + offset | 0);
  };
  var yToLatch = function (y, dy) {
    if (Pervasives.abs(dy) < 20) {
      return latch;
    } else if (dy < 0) {
      return /* Top */0;
    } else {
      return /* Bottom */1;
    }
  };
  var latchToY = function (latch) {
    if (typeof latch !== "number") {
      return 30;
    }
    switch (latch) {
      case /* Top */0:
        return 30;
      case /* Bottom */1:
        return visualMediaHeight + offset | 0;
      case /* OffScreen */2:
        return windowHeight;
    }
  };
  var trackLatchEvent = function (next, direction) {
    if (typeof next !== "number") {
      return;
    }
    switch (next) {
      case /* Top */0:
        if (direction !== -1) {
          return;
        } else {
          return Curry.app(trackEvent, ["Swiped Products Drawer Up To Top", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        }
      case /* Bottom */1:
        if (direction !== 1) {
          return;
        } else {
          return Curry.app(trackEvent, ["Swiped Products Drawer Down To Bottom", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        }
      case /* OffScreen */2:
        return;
    }
  };
  var scrollRef = React.useRef(null);
  var isScrollAtZero = function (param) {
    return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollRef.current), function (el) {
      var scrollTop = el.scrollTop | 0;
      return scrollTop === 0;
    }), false);
  };
  var isDragAllowed = function (touchTarget) {
    var touchTargetIsScroll = Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollRef.current), function (el) {
      if (Caml_obj.equal(el, touchTarget)) {
        return true;
      } else {
        return DOMUtils$Showside.isDescendent(el, touchTarget);
      }
    }), false);
    if (touchTargetIsScroll && !isScrollAtZero(undefined)) {
      return latch === /* Bottom */1;
    } else {
      return true;
    }
  };
  var onTouchMove = function (e) {
    var target = e.target;
    if (isDragAllowed(target)) {
      var nextFingerY = getTouchY(e);
      if (drag !== undefined) {
        var movement = nextFingerY - drag.fingerStartY | 0;
        Curry._1(setDrag, function (param) {
          return {
            drawerStartY: drag.drawerStartY,
            drawerCurrentY: limit(drag.drawerStartY + movement | 0),
            fingerStartY: drag.fingerStartY,
            fingerCurrentY: nextFingerY
          };
        });
      } else {
        Curry._1(setDrag, function (param) {
          return {
            drawerStartY: latchToY(latch),
            drawerCurrentY: latchToY(latch),
            fingerStartY: nextFingerY,
            fingerCurrentY: nextFingerY
          };
        });
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };
  var onTouchEnd = function (e) {
    if (drag === undefined) {
      return;
    }
    var movement = drag.fingerCurrentY - drag.fingerStartY | 0;
    var nextLatch = yToLatch(drag.drawerCurrentY, movement);
    trackLatchEvent(nextLatch, movement);
    Curry._1(onChangeLatch, nextLatch);
    Curry._1(setDrag, function (param) {});
  };
  var handle = React.createElement("div", {
    className: CSS$Showside.prefix("flex justify-center p-3 relative bg-main")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex justify-center bg-primary opacity-25 rounded-full w-16 h-1.5")
  }));
  var activeY = drag !== undefined ? drag.drawerCurrentY : latchToY(latch);
  var prevActiveY = Previous$Showside.usePreviousDistinct(activeY);
  var visualDrawerHeight = windowHeight - activeY | 0;
  var showViewProducts = visualDrawerHeight < 160;
  var flipViewProducts = visualMediaHeight / visualMediaWidth <= 1.0;
  var flipViewProducts$1 = flipViewProducts && latch !== /* OffScreen */2;
  var scrollToRef = React.useRef(function (param) {});
  var invisibleExtraTop = React.createElement("div", {
    className: CSS$Showside.prefix("absolute w-full top-0 h-20 -mt-20")
  });
  var style = {
    height: String(windowHeight) + "px",
    paddingBottom: CSS$Showside.intToPx(30),
    transform: CSS$Showside.translate3d(0, activeY, 0)
  };
  var latchChanged = latch !== prevLatch;
  var yChanged = activeY !== prevActiveY;
  var transitionCn = drag === undefined && (latchChanged || yChanged) && !Curry._1(didEdgeSwipe, undefined) ? "transition-transform duration-200" : "";
  return React.createElement(React.Fragment, undefined, flipViewProducts$1 ? Curry._3(renderViewProductsButton, showViewProducts, flipViewProducts$1, visualMediaHeight) : null, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["fixed top-0 w-full flex flex-col select-none touch-none", "pointer-events-auto", transitionCn, "product_drawer"])),
    style: style,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove
  }, latch === /* Top */0 ? invisibleExtraTop : null, flipViewProducts$1 ? null : Curry._3(renderViewProductsButton, showViewProducts, flipViewProducts$1, visualMediaHeight), handle, React.createElement("div", {
    className: CSS$Showside.prefix("relative h-full bg-main -top-px"),
    style: {
      maxHeight: "calc(100vh - 51px)"
    }
  }, React.createElement(Scrollable$Showside.make, {
    restorationId: "mobile-drawer",
    scrollToRef: scrollToRef,
    children: latch === /* OffScreen */2 ? null : children,
    locked: latch !== /* Top */0,
    fwdRef: scrollRef
  }))));
}
QuickViewSlideUpDrawer.displayName = "QuickViewSlideUpDrawer";
var make = QuickViewSlideUpDrawer;
export { getTouchY, make };
/* react Not a pure module */